import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../../../context/AuthProvider';
import Toast from "../../../assetLibComponents/shared/Toast";
import { Mixpanel } from '../../../../Mixpanel';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router';
import Loading from '../../Loading';


const VerifyAccount = () => {

    const authCtx = useContext(AuthContext);
  const VERIFY_URL = authCtx.verifyAccount;
  let navigate = useNavigate();
  const [eString, setEString] = useState("");
  // const [action, setAction] = useState("");
  // const [code, setCode] = useState("");


  // const verifyEndpoint = VERIFY_URL+code ;


  useEffect(() => {

    const url = window.location.href;

    // Extract the string after "verifyAccount"
    const startIndex = url.indexOf('verifyAccount/') + 'verifyAccount/'.length;
    const extractedString = url.substring(startIndex);
      // Log or use the extracted value
    setEString(extractedString);
    
  }, []);

  useEffect(()=>{
    if(eString?.length > 0){
      const indexOfAction = eString.indexOf("&action");
      const before = eString.substring(0, indexOfAction);
      const urlParams = new URLSearchParams(eString);
      const action = urlParams.get('action');
      verifyAccount(before, action)
    }
  },[eString])

  

    const verifyAccount = async (code,action) => {
        try {
          const response = await axios.post(VERIFY_URL,{
            user_token:code,
            action:action
          });
          if (response?.data?.statusCode === "401") {
            console.log("ERR-401");
            // Toast(response?.data?.message, "E");
            Toast(response?.data?.message, "E");
            // setButtonLoader(false);
          }else if (response?.data?.statusCode === "403"){
            // console.log(response?.data?.data)
            // setResendMail(true);
            window.location.assign("/");
            localStorage.setItem("resendData", JSON.stringify(response?.data?.data));
          }else if (response?.data?.statusCode === "200") {
            Mixpanel.track('LoggedIn');
            Cookies.set("conditionalLogout", false );        
            authCtx.onLogin(response?.data);
            window.location.reload();
            const randomId = Math.floor(Math.random() * 900000) + 100000; // Generate a random token
            const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
            Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate }); // Set the cookie with the random token
            navigate("/Chat-Ai");
            // setButtonLoader(false);
          } else {
            Toast(response?.data?.response, "E");
            // setButtonLoader(false);
          }
          Cookies.set("conditionalLogout", false );   
        //   setUsername("");
        //   setPassword("");
        } catch (err) {
        //   setButtonLoader(false);
          console.log("ERR",err);
        }
      };

  return (
    <div><Loading /></div>
  )
}

export default VerifyAccount